import { FC, ReactNode, createContext, useEffect } from "react";

interface PopoutRootProps {
    children: ReactNode
    activePopout: string | null
}

const DEFAULT_VALUE = null

export const PopoutRootContext = createContext<string | null>(DEFAULT_VALUE);

export const PopoutRoot: FC<PopoutRootProps> = ({
    children,
    activePopout
}) => {
    useEffect(() => {
        if (!activePopout) return undefined

        const previousOverflow = document.body.style.overflow
        const previousPaddingRight = document.body.style.paddingRight
        const previousScrollLockGap = document.documentElement.style.getPropertyValue('--scroll-lock-gap')
        const hasStableGutter = window.getComputedStyle(document.documentElement).getPropertyValue('scrollbar-gutter').includes('stable')
        const scrollbarWidth = hasStableGutter ? 0 : window.innerWidth - document.documentElement.clientWidth
        const paddingRight = window.getComputedStyle(document.body).paddingRight

        document.body.style.overflow = 'hidden'
        if (scrollbarWidth) document.body.style.paddingRight = `calc(${paddingRight} + ${scrollbarWidth}px)`
        document.documentElement.style.setProperty('--scroll-lock-gap', `${scrollbarWidth}px`)

        return () => {
            document.body.style.overflow = previousOverflow
            document.body.style.paddingRight = previousPaddingRight
            if (previousScrollLockGap) document.documentElement.style.setProperty('--scroll-lock-gap', previousScrollLockGap)
            else document.documentElement.style.removeProperty('--scroll-lock-gap')
        }
    }, [activePopout]);

    return (
        <PopoutRootContext.Provider
            value={activePopout}
        >
            <div className="popoutRoot">
                {children}
            </div>
        </PopoutRootContext.Provider>
    )
}
